<script setup lang="ts">
definePage({
  redirect: "/",
});

// import ArtOfGivingEvent from "@/components/events/ArtOfGivingEvent.vue";
</script>

<template>
  <!-- <ArtOfGivingEvent /> -->
</template>
